<template>
    <div class="main_wrapper ion-padding">
        <div class="maintenace_mode">
            <img src="@/assets/img/logo_icon.svg" alt="" class="logo">
            <img src="@/assets/img/logo_text.svg" alt="" class="logo">
            <div class="header">
                Sorry for the inconvenience.
            </div>
            <div class="maintenance_text">
                {{ maintenanceModeText }}

            </div>

        </div>

    </div>
</template>


<script>

import {
    onBeforeMount,
    onMounted,
    onUnmounted,
    ref
} from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default {

    setup() {

        const maintenanceModeText = ref();
        const store = useStore();
        const router = useRouter();

        onMounted(() => {
            $('body').addClass('background_blue');
            maintenanceModeText.value = 'We are currently performing maintenance on our system. We will be back shortly. Please check back soon.';
        });

        onBeforeMount(async() => {
            const resp = await store.dispatch('CHECK_MAINTENANCE_MODE');
            if (resp.data == 1) {
                router.push({ name: 'auth' });
            }
        });

        onUnmounted(() => {
            $('body').removeClass('background_blue');
        });

        return {
            maintenanceModeText
        }
    }
}
</script>